<template>
  <div style="background: #fff">
    <div class="soluBanner">
      <el-carousel :interval="5000" :height="imgHeight + 'px'">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <a v-if="item.linkUrl" :href="item.linkUrl" target="_blank">
            <img :src="item.value" alt="" style="width: 100%" ref="image" />
          </a>
          <a v-else href="javascript:void(0)">
            <img :src="item.value" alt="" style="width: 100%" ref="image" />
          </a>
          <div class="soluBanBox"></div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div style="background: #fff;">
      <div class="soluBottomRTit flex">
        <!-- <div class="soluBottomRTit2" @click="findAll">
          <p>新闻资讯</p>
        </div> -->
        <div class="soluBottomInput">
          <div class="soluBottomRTit2 gray soluRightBtn">
            <span style="color: #808080">当前位置：</span>
      		    <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>新闻资讯</el-breadcrumb-item>
              </el-breadcrumb>
          </div>
        </div>
        <div class="soluBottomInput">
          <input  type="text" placeholder="输入关键词" v-model="title">
          <i class="el-icon-search"  @click="searchInput()"></i>
        </div>

      </div>
    </div>
    <div class="newSwiperBox">
      <div class="newSwiperBoxCarousel">
        <el-carousel height="300px">
          <el-carousel-item v-for="(item, index) in newsList" :key="index">
            <div @click="getNewsItemDetail(item.uuid)"  style="display: flex;cursor: pointer;">
              <img
                :src="item.pictureUrl"
                alt=""
                class="newSwiperBoxImg"
              />
              <div>
                <h3 class="smallH3">{{ item.title }}</h3>
                <!-- <p class="newMesg" v-html="item.content"></p> summary -->
                <p class="newMesg">
                  {{ item.summary }}
                </p>
                <p class="newDate">
                  <i class="el-icon-time"></i>
                  <span>{{ item.publishDate }}</span>
                </p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="soluBottom flex">
      <div style="margin-top: 40px">
        <div
          class="soluBottomL"
          v-for="(newitems, indexs) in newList"
          :key="indexs"
        >
          <p
            class="soluBottomLP"
            :class="soluIndex == indexs ? 'soluBottomLP_active' : ''"
            @click="getSoluTbas(newitems, indexs)"
          >
            {{ newitems.title }}
          </p>
          <!-- 如果有children -->
          <p
            v-if="newitems.childSolutTabs"
            class="soluBottomLCh"
            :class="soluIndex2 == indexChild ? 'soluBottomLCh_active' : ''"
            v-for="(itemChild, indexChild) in newitems.children"
            :key="indexChild"
            @click="getSoluTbasChildren(itemChild, indexChild)"
          >
            {{ itemChild.title }}
          </p>
        </div>
      </div>
      <div class="soluBottomR">
        <div class="suluBottomBig" v-if="!showNoNews">
          <div
            class="soluBottomRList flex"
            v-for="(items, index) in solutionList"
            :key="index"
            @click="getNewsItemDetail(items.uuid)"
          >
            <div class="soluBottomRImg">
              <img :src="items.pictureUrl" alt="" />
            </div>
            <div class="soluBottomRMess">
              <h4>{{ items.title }}</h4>
              <p class="soluBottomRMessP">
                {{ items.summary }}
              </p>
              <div class="new_times flex">
                <p class="flex" style="align-items: center">
                  <i class="el-icon-time" style="margin-right: 5px"></i>
                  <span> {{ items.publishDate }} </span>
                </p>
                <p class="flex" style="align-items: center">
                  <i class="el-icon-reading" style="margin-right: 5px"></i>
                  <span> {{ items.pageViews }} </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showNoNews" class="suluBottomBig2">
          <!-- 暂无数据 -->
          <img src="../../assets/nosearchMesg.jpg" style="width: 200px;" />
        </div>
        <!-- 分页 -->
        <div class="pageina" v-if="!showNoNews">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="current"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  queryNewText,
  getNewsProgramTreeList,
  getBannerList,
} from "../../utils/interface";
import { mapState } from "vuex";
import {findWordInfoList} from "../../utils/wordInfo";

export default {
  //   新闻
  name: "news",
  metaInfo: {
    title: "水泵行业资讯——水泵云", // set a title
    meta: [
      {
        // set meta
        name: "keywords",
        content:
          "水泵|水泵制造|水泵行业资讯|水泵新闻|水泵政策|水泵行业数据|水泵技术|水泵云|水泵制造行业政策|树脂水泵|金属水泵|生物水泵|智能制造",
      },
      {
        // set meta
        name: "description",
        content:
          "水泵云，每日精选水泵业内重点新闻，及时传递价值讯息。水泵云是安徽水泵云数字科技有限公司打造的水泵制造领域综合性工业互联网平台。聚合水泵产业链六大资源，水泵模型资源、设计师资源、生产制造资源、产品资源、课程资源、软件资源。并提供四大解决方案：智能制造标准体系的智能工厂解决方案、基于标识解析体系的远程运维解决方案、基于C2M模式的水泵个性化定制解决方案、水泵制造行业企业数字化解决方案。",
      },
    ],
  },
  components: {},
  data() {
    return {
      showNoNews: false,
      clickNum: null,
      imgHeight: "",
      imgHeightsetIn: null,
      groupCode: "NEWS_BANNER",
      bannerList: [
        {
          value: "",
        },
      ],
      solutionList: [],
      newList: [
        {
          title: "",
          children: [
            {
              title: "",
            },
          ],
        },
      ],
      parkActiveIndex: 0,
      soluIndex: 0,
      soluIndex2: null,
      // 分页
      current: 1,
      pageSize: 10,
      total: 0,
      soluTabsIndex: null,
      newListIndex: null,
      programUuid: "",
      status: "PUBLISH",
      opends: ["0"],
      title: "",
      timer: null,
      setIn: null, // 定时器
      titleMessage: "",
      indexElmenu: false,
      defaultActive: "1",
      newsList: [
        {
          title: "烟台2023年积水点位、雨水泵站改造及河",
          message:
            "023年积水点位、雨水泵站改造及河道清淤维修工程是市区城建重点项目。该工程计划对港城西大街、魁玉路、通世南路山水龙城站点、北马路与海港路路口、奇山红旗中路等积水点位进行改造；对钢管河、南通河等河道及沿海沿河截流口进行清淤维修；对西牟、970公铁立交桥等雨水泵站......",
          time: "2023/06/23",
        },
        {
          title: "雨水泵站改造及河",
          message:
            "雨水泵站改造及河道清淤维修工程是市区城建重点项目。该工程计划对港城西大街、魁玉路、通世南路山水龙城站点、北马路与海港路路口、奇山红旗中路等积水点位进行改造；对钢管河、南通河等河道及沿海沿河截流口进行清淤维修；对西牟、970公铁立交桥等雨水泵站......",
          time: "2023/06/23",
        },
      ],
    };
  },
  watch: {
    title() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.getSolutionList();
      }, 100);
    },
  },
  created() {
    this.setIn = setInterval(() => {
      if (this.isTokenDoor === true) {
        clearInterval(this.setIn);
        this.getBannerList();
        this.programUuid = this.$route.params.programUuid;
        this.getProgramList(this.programUuid);
        this.getCarouseData();
      }
    }, 500);
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  mounted() {
    window.scrollTo(0, 0);
    // if (this.bannerList.length !== 0) {
    window.addEventListener("resize", () => {
      this.imgHeight = this.$refs.image[0].height;
    });
    // }
  },
  methods: {
    imgLoad() {
      this.$nextTick(function() {
        // 获取窗口宽度*图片的比例，定义页面初始的轮播图高度
        // this.imgHeight = (document.body.clientWidth * 1) / 4;
        this.imgHeightsetIn = setInterval(() => {
          if (this.imgHeight == 0) {
            this.imgHeight = this.$refs.image[0].height;
            // console.log(5555, this.imgHeight);
          } else {
            clearInterval(this.imgHeightsetIn);
            // console.log(6666, this.imgHeight);
          }
        }, 520);
      });
    },
    handleOpen(key, keyPath) {
      this.newListIndex = key;
      this.programUuid = this.newList[key].uuid;
      this.soluTabsIndex = undefined;
      this.getSolutionList();
    },
    handleClose(key, keyPath) {
      this.newListIndex = undefined;
      this.soluTabsIndex = undefined;
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getSolutionList();
    },
    handleCurrentChange(val) {
      this.current = val;
      window.scrollTo(0, 0);
      this.getSolutionList();
    },
    getBannerList() {
      let params = {
        groupCode: this.groupCode,
      };
      getBannerList(params).then((res) => {
        // if (res.length !== 0) {
        this.bannerList = res;
        this.imgLoad();
        // }
      });
    },

    getProgramList(programUuid) {
      let params = {
        // name:'',
        // survival:this.survival,
        ignoreOrigin: "ASSOCIATION",
        current: 1,
        pageSize: 10,
      };
      getNewsProgramTreeList(params).then((res) => {
        this.newList = res;
        this.programUuid = res[0].uuid;
        this.getSolutionList();
        if (programUuid != null) {
          this.newList.forEach((news, t) => {
            if (news.children != null) {
              news.children.forEach((item, tIndex) => {
                if (item.uuid == programUuid) {
                  item.active = true;
                  this.soluTabsIndex = tIndex;
                  this.newListIndex = t;
                } else {
                  item.active = false;
                }
              });
            }
          });
        }
      });
    },
    getSoluTbasChildren(item, i) {
      this.soluIndex2 = i;
      this.programUuid = item.uuid;
      this.getSolutionList();
    },
    getSoluTbas(item, i) {
      this.soluIndex2 = null;
      this.soluIndex = i;
      this.newList.map((items) => {
        items.childSolutTabs = false;
      });
      if (item.children) {
        item.childSolutTabs = !item.childSolutTabs;
      } else {
        item.childSolutTabs = false;
      }
      this.programUuid = item.uuid;
      // this.newList.forEach((news, t) => {
      //   if (news.children != null) {
      //     news.children.forEach((item, tIndex) => {
      //       if (i != t || tIndex !== index) {
      //         item.active = false;
      //       } else {
      //         item.active = true;
      //       }
      //     });
      //   }
      // });
      // this.soluTabsIndex = index;
      // this.newListIndex = i;
      this.getSolutionList();
    },
    fn(index) {
      this.clickNum = index;
    },
    // 获取轮播的五条数据
    getCarouseData() {
      let params = {
        ignoreOrigin: "ASSOCIATION",
        status: "PUBLISH",
        pageSize: 5,
      };
      queryNewText(params).then((res) => {
        if (res.success) {
          this.newsList = res.data;
        }
      });
    },
    getSolutionList() {
      let params = {
        // name:'',
        status: "PUBLISH",
        programUuid: this.programUuid,
        title: this.title,
        // programName:this.programName,
        current: this.current,
        pageSize: this.pageSize,
      };
      queryNewText(params).then((res) => {
        if (res.success) {
          this.solutionList = res.data;
          this.total = res.total;
          if (this.total > 0) {
            this.showNoNews = false;
          } else {
            this.showNoNews = true;
          }
        } else {
          this.showNoNews = true;
        }
      });
    },
    getNewsItemDetail(uuid) {
      let routeData = this.$router.resolve({
        name: "newDetails",
        params: {
          uuid: uuid,
        },
      });
      window.open(routeData.href, "_blank");
    },
    findAll() {
      this.programUuid = null;
      this.newListIndex = null;
      this.soluTabsIndex = null;
      this.getSolutionList();
      this.newList.forEach((news, t) => {
        if (news.children != null) {
          news.children.forEach((item, tIndex) => {
            item.active = false;
          });
        }
      });
    },
    searchInput(){
      let params = {
        // name:'',
        status: "PUBLISH",
        programUuid: this.programUuid,
        title: this.title,
        current: this.current,
        pageSize: this.pageSize,
      };
      queryNewText(params).then((res) => {
        if (res.success) {
          this.solutionList = res.data;
          this.total = res.total;
          if (this.total > 0) {
            this.showNoNews = false;
          } else {
            this.showNoNews = true;
          }
        } else {
          this.showNoNews = true;
        }
      });

    },
  },
};
</script>

<style scoped lang="less">
.blue {
  color: #009999;
}
.soluBanner {
  position: relative;
  width: 100%;
  img {
    width: 100%;
    display: block;
  }
  .soluBanBox {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1200px;
    transform: translate(-50%, -50%);
    color: #fff;
    h2 {
      font-size: 38px;
      letter-spacing: 10px;
    }
    .soluBanText {
      p:nth-child(1) {
        font-size: 17px;
      }
      p:nth-child(2) {
        font-size: 9px;
      }
    }
  }
}
.soluBottomRTit {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0 20px;
  line-height: 12px;
  justify-content: space-between;
  align-items: center;

  .soluBottomInput {
    position: relative;
    input {
      border: none;
      background: #efefef;
      padding: 5px 13px;
      border-radius: 30px;
      height: 20px;
      width: 158px;
      font-size: 12px;
      color: #969696;
    }
    i {
      position: absolute;
      right: 5%;
      top: 50%;
      color: #969696;
      transform: translate(0, -50%);
    }
  }

  .soluBottomRFlex {
    align-items: center;
  }
  .soluBottomRTit2 {
    text-align: left;
    font-size: 28px;
    font-weight: 600;
    color: #1d1d1d;
    i {
      display: inline-block;
      background: #009999;
      width: 20px;
      height: 2px;
      position: absolute;
      bottom: 0;
      left: 0;
    }
    p {
      /*margin-bottom: 6px;*/
      line-height: 30px;
    }
  }
  .soluRightBtn {
    font-size: 14px;
    color: #6e6e6e;
    display: flex;
    align-items: center;
    font-weight: 400;
    .solutionTitle {
      margin-left: 8px;
      color: rgba(0, 0, 0, 0.88);
    }
    .solutHome {
      cursor: pointer;
    }
  }
  .newsLittleT {
    font-size: 13px;
    color: #777;
    cursor: pointer;
  }
  // .newsLittleIcon {
  //   display: inline-block;
  //   width: 2px;
  //   height: 16px;
  //   background: #efefef;
  //   margin: 0 6px;
  // }
  .newsLittleIcon2 {
    display: inline-block;
    margin: 0 6px;
    color: #777;
  }
}
/deep/.el-submenu__title {
  font-size: 16px;
  border-bottom: 1px solid #efefef;
}
.active {
  background: #409eff;
  span {
    color: #fff !important;
  }
}
/deep/.el-submenu.is-active .el-submenu__title {
  border-bottom: 1px solid #efefef;
}
/deep/.el-submenu .el-menu-item {
  border-bottom: 1px solid #efefef;
}
/deep/.el-menu-item-group__title {
  padding: 0;
}
.newSwiperBox {
  height: 420px;
  background: url("../../assets/newBanner.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .newSwiperBoxImg {
    // width: 585px;
    height: 300px;
    margin-right: 30px;
  }
  .newSwiperBoxCarousel {
    width: 1200px;
    /deep/.el-carousel__button {
      width: 4px !important;
      height: 4px !important;
      border-radius: 50% !important;
      background-color: #009999;
      text-align: right;
    }
    /deep/.el-carousel__indicators--horizontal {
      left: 90%;
    }
    .smallH3 {
      font-size: 20px;
      margin-bottom: 30px;
    }
    .newMesg {
      color: #6e6e6e;
      font-size: 16px;
      margin-bottom: 76px;
      line-height: 32px;
      display: -webkit-box;
      overflow: hidden;
      white-space: normal !important;
      text-overflow: ellipsis;
      word-wrap: break-word;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
    }
    .newDate {
      color: #6e6e6e;
      font-size: 14px;
    }
  }
}
.soluBottom {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 40px;
  border-left: 1px solid #efefef;

  .soluBottomLtwo {
    background-color: #60a5f4;
    color: #fff;
    text-align: center;
    width: 255px;
    flex-shrink: 0;
  }
  .soluBottomL {
    text-align: center;
    width: 236px;
    flex-shrink: 0;
    background-color: #fff;

    .soluBottomLP_active {
      color: #fff;
      background: #009999;
      border-radius: 0px 20px 20px 0px;
    }
    .soluBottomLP {
      width: 236px;
      height: 40px;
      line-height: 40px;
      margin-top: 26px;
      cursor: pointer;
      &:hover {
        background: #00999970;
        border-radius: 0px 20px 20px 0px;
      }
    }
    .soluBottomLTit {
      font-size: 18px;
      color: #fff;
      background: #009999;
      text-align: center;
      height: 80px;
      line-height: 80px;
    }
    .soluBottomLtab {
      font-size: 14px;
      text-align: center;
      border: 1px solid #efefef;
      box-shadow: 0px 1px 7px 0px #dadada;

      p {
        height: 58px;
        line-height: 58px;
        border-bottom: 1px solid #efefef;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;

        // span {
        //   margin-left: 10px;
        // }
      }
      p:nth-last-child(1) {
        border-bottom: none;
      }
      .p_active {
        width: 100%;
        background: #e7f2ff;
      }
    }
    .soluBottomLtab_active {
      background: #009999;
      height: 15px;
      width: 3px;
      display: inline-block;
    }
    .soluBottomLCh {
      background: #efefef;
      font-size: 14px;
      line-height: 40px;
      margin-top: 0px;
      cursor: pointer;
      border-radius: 0px 20px 20px 0px;

    }
    .soluBottomLCh_active {
      color: #fff;
      background: #0099996e;
      border-radius: 0px 20px 20px 0px;

    }
  }
  .soluBottomR {
    margin-left: 28px;
    width: 100%;
    .suluBottomBig2 {
      margin-left: 28px;
      width: 100%;
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      color: #d4d4d4;
      line-height: 650%;
    }
    .suluBottomBig {
      flex-wrap: wrap;
      justify-content: space-between;
      padding-top: 40px;

      .soluBottomRList {
        cursor: pointer;
        background: #fff;
        margin-bottom: 18px;
        // width: 45%;
        // height: 120px;
        padding: 15px;
        border-radius: 10px;
        .soluBottomRImg {
          width: 284px;
          margin-right: 40px;
          flex-shrink: 0;
          img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }
        .soluBottomRMess {
          min-width:400px;
          position: relative;
          h4 {
            font-size: 16px;
            display: -webkit-box;
            overflow: hidden;
            white-space: normal !important;
            text-overflow: ellipsis;
            word-wrap: break-word;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
              "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
              "Helvetica Neue";
          }
          .soluBottomRMessP {
            color: #777;
            font-size: 14px;
            margin-top: 20px;
            line-height: 22px;
            display: -webkit-box;
            overflow: hidden;
            white-space: normal !important;
            text-overflow: ellipsis;
            word-wrap: break-word;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .new_times {
            position: absolute;
            font-size: 12px;
            color: #b1b1b1;
            bottom: 0;
            p:nth-child(2) {
              margin: 0 22px;
            }
          }
        }
      }
    }
    .pageina {
      margin-top: 74px;
      text-align: right;
      /deep/.el-pagination button:disabled {
        background-color: transparent;
        border: 1px solid #efefef;
        border-radius: 5px;
      }
      /deep/.el-pagination .btn-prev {
        padding-right: 0;
      }
      /deep/.el-pager li {
        border: 1px solid #efefef;
        border-radius: 5px;
        margin: 0 5px;
      }
      /deep/.el-pager li.active {
        border: 1px solid #009999;
        color: #009999;
      }
    }
  }
}
/deep/.el-submenu__title:hover {
  background: #60a5f4;
  color: #fff;
}
/deep/.el-menu {
  background-color: none;
}
.soluBottomL /deep/ .el-submenu__title {
  // background: chartreuse;
}
// .el-menu-vertical-demo {
//   // background-color: #60a5f4;
//   span {
//     color: #fff;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/news/index.vue